import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Fab,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";

import {
  getEmpearningSalary,
  getUnpaidUser,
  viewPaymentSlip,
} from "../paymentReceipt/paymentReceiptApi";

import { useSelector } from "react-redux";
import { getAllEnquiriesById } from "./instituteApi";

const Enquiries = ({ backEnquire, enquiries, Resale }) => {
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab,
  );
  const [enquiry, setenquiry] = useState();
  const [totalEnquiry, setTotalEnquiry] = useState();

  const getAllApplieded = async (param) => {
    const payload = {
      courseId: enquiries.id,
    };

    getAllEnquiriesById(payload, (data) => {
      console.log("enquiries ", data.data.data.list);
      const datalist = data.data;
      setenquiry(datalist.data.list);
      setTotalEnquiry(datalist.data.totalRecords);
    });
  };

  useEffect(() => {
    getAllApplieded();
  }, []);

  const tableGrid = {
    display: "grid",
    gridTemplateColumns: `
    minmax(140px, 1.2fr)  
    minmax(220px, 2fr)     
    minmax(160px, 1.5fr)   
    minmax(220px, 2fr)    
    minmax(260px, 3fr)     
  `,
    alignItems: "center",
    columnGap: "12px",
  };

  const formatDate = (date) =>
    new Date(date)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");

  return (
    <>
      {/* <DynamicBreadcrumbs /> */}
      <Box
        px={{ xs: 2, sm: 4 }}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Grid container spacing={{ xs: 1, sm: 2 }}>
          <IconButton
            onClick={() => backEnquire()}
            sx={{
              "&:hover": {
                backgroundColor: "transparent", // removes hover background
              },
            }}
            // sx={{
            //   color: "#01008B",
            //   padding: "40px", // increases clickable area
            //   width: "50px", // optional fixed width
            //   height: "45px",
            // }}
          >
            {/* <ArrowBackIcon
              sx={{
                fontSize: {
                  xs: "20px",
                  sm: "24px",
                  md: "30px", // icon size increase
                },
              }}
            /> */}
            <KeyboardBackspaceIcon sx={{ fontSize: 30, color: "#01008B" }} />
          </IconButton>

          <Grid
            item
            xs={12}
            sm={10}
            // sx={{
            //   background:
            //     "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
            //   padding: "10px",
            //   mt: "10px",
            //   borderRadius: "5px",
            //   color: "#01008B",
            //   textAlign: "left",
            //   marginBottom: "20px",
            //   fontFamily: "'Montserrat', sans-serif",
            //   fontSize: "20px",
            //   fontWeight: 500,
            // }}
          >
            <Box
              sx={{
                background:
                  "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
                padding: "10px",
                mt: "10px",
                borderRadius: "5px",
                color: "#01008B",
                textAlign: "left",
                marginBottom: "20px",
                fontFamily: "'Montserrat', sans-serif",
                fontSize: "20px",
                fontWeight: 500,
              }}
            >
              <Typography
                variant="h6"
                fontSize={{
                  xs: "12px",
                  sm: "13px",
                  md: "20px",
                }}
              >
                {Resale ? "Resale Furniture & Equipments" : "Enquiries"}
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={12} sx={{ p: 0 }}>
            <Typography
              variant="h6"
              sx={{
                color: "#01008B",
                fontSize: {
                  xs: "12px",
                  sm: "13px",
                  md: "24px",
                },
                fontWeight: 600,
              }}
            >
              {enquiries.courseName}
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ p: 0 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <Typography
                sx={{
                  color: "#01008B",
                  fontSize: {
                    xs: "12px",
                    sm: "13px",
                    md: "15px",
                  },
                  fontWeight: 500,
                }}
              >
                course id - {enquiries.id}
              </Typography>
              <Typography
                sx={{
                  color: "#01008B",
                  fontSize: {
                    xs: "13px",
                    sm: "16px",
                    md: "20px",
                  },
                  fontWeight: 500,
                }}
              >
                Total Enquiries - {totalEnquiry}
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Box
          sx={{
            backgroundColor: "white",
            px: 2,
            py: 2,
            mt: 2,
            borderRadius: "12px",
            overflow: "auto",
            height: "75vh",
          }}
        >
          <Box sx={{ minWidth: "1100px" }}>
            {/* HEADER */}
            <Box
              sx={{
                ...tableGrid,
                borderBottom: "1.5px solid black",
                p: "10px",
              }}
            >
              <Box sx={{ color: "#01008B", fontWeight: 500 }}>
                Date of Enquiry
              </Box>

              <Box
                sx={{ textAlign: "center", color: "#01008B", fontWeight: 500 }}
              >
                {Resale ? "Name" : "Candidate Name"}
              </Box>

              <Box
                sx={{ textAlign: "left", color: "#01008B", fontWeight: 500 }}
              >
                Mobile No.
              </Box>

              <Box
                sx={{ textAlign: "left", color: "#01008B", fontWeight: 500 }}
              >
                Email Id
              </Box>

              <Box
                sx={{ textAlign: "left", color: "#01008B", fontWeight: 500 }}
              >
                Address
              </Box>

              <Box />
            </Box>

            {/* DATA ROW */}
            {enquiry?.map((enq, index) => {
              return (
                <Box
                  sx={{
                    ...tableGrid,
                    backgroundColor: "#E8E8FF",
                    borderRadius: "8px",
                    mt: 1,
                    mb: 1,
                    p: 1, // 👈 padding on row, not inner items

                    width: "fit-content",
                  }}
                >
                  <Box sx={{ px: 2, fontWeight: "medium" }}>
                    {formatDate(enq?.appliedDate) || "-"}
                  </Box>

                  <Box sx={{ textAlign: "center", fontWeight: "medium" }}>
                    {enq?.userName || "-"}
                  </Box>

                  <Box sx={{ textAlign: "center" }}>
                    {enq?.userMobile || "-"} {/* {mobileNumber && ( */}
                    <IconButton
                      size="small"
                      sx={{ p: 0 }}
                      onClick={() =>
                        window.open(
                          `https://web.whatsapp.com/send?phone=${enq?.userMobile}`,
                          "_blank",
                        )
                      }
                    >
                      <WhatsAppIcon
                        sx={{
                          color: "white",
                          fontSize: 20,
                          borderRadius: "50%",
                          backgroundColor: "#25D366",
                          p: "3px",
                        }}
                      />
                    </IconButton>
                    {/* )} */}
                  </Box>

                  <Box sx={{ fontWeight: "medium" }}>
                    {enq?.userEmail || "-"}
                  </Box>

                  <Box sx={{ textAlign: "center", fontWeight: "medium" }}>
                    {enq?.userAddress || "-"}
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Enquiries;
